import React from 'react';

const LeagueCircleSelector = ({ leagues, selectedLeague, onSelect }) => {
  if (!leagues?.length) return null;

  return (
    <div className="league-selector">
      <div className="league-circles">
        {leagues.map((league) => (
          <button
            key={league.code}
            type="button"
            className={`league-circle ${selectedLeague?.code === league.code ? 'league-circle--selected' : ''}`}
            style={{
              background:
                selectedLeague?.code === league.code
                  ? `linear-gradient(135deg, ${league.color || '#4f46e5'}, #6d28d9)`
                  : 'var(--sc-bg-elevated)',
              color: selectedLeague?.code === league.code ? 'white' : 'var(--sc-text-muted)'
            }}
            onClick={() => {
              if (selectedLeague?.code === league.code) return;
              onSelect(league);
            }}
            title={league.name}
          >
            <img
              src={`/flags/${league.code.toLowerCase()}.svg`}
              alt={league.name}
              className="league-circle__flag"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default LeagueCircleSelector;
